module.exports = __webpack_public_path__ + "static/media/roboto_regular.176f8f5b.woff2";